import { Injectable, inject } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { ApiService } from "@core/api/api.service";

import { HelpService } from "@theme/@confect/services/confect-help.service";

import { Subject, filter, takeUntil } from "rxjs";

import { CAuthService } from "./auth.service";
import { HotjarService } from "./hotjar.service";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class InitService {
  private api = inject(ApiService);
  private us = inject(UserService);
  private router = inject(Router);
  private hj = inject(HotjarService);
  private auth = inject(CAuthService);
  private hs = inject(HelpService);

  public hasInitialized = false;
  public hasInitializedHubspot = false;

  unsubscribe$ = new Subject<boolean>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  private initTracking() {
    // Track subsequent screens
    this.router.events
      .pipe(
        // For navigation debugging
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((event: NavigationEnd) => {
        this.api.trackScreen(event.url).subscribe();
      });
  }

  public getUnreadChanges() {
    if (!this.hasInitializedHubspot) {
      (window as any).HubSpotConversations?.on(
        "unreadConversationCountChanged",
        (payload) => {
          this.hs.unreadSubject.next(payload.unreadCount);
        },
      );
      this.hasInitializedHubspot = true;
    }
  }

  public initHubspot() {
    (window as any).HubSpotConversations?.widget.remove();

    this.api.hubspotIdentify().subscribe({
      next: (res) => {
        (window as any).hsConversationsSettings = {
          identificationEmail: res.email,
          identificationToken: res.token ?? "",
          inlineEmbedSelector: "#hubSpotChat",
          avoidInlineStyles: true,
        };
        (window as any).HubSpotConversations?.widget.load();

        // Monitor chats to identify
        (window as any).HubSpotConversations?.on(
          "conversationStarted",
          (payload) => {
            const conv = payload?.conversation?.conversationId ?? null;
            if (conv != null) {
              this.api
                .hubspotChatStarted(conv, this.router.url)
                .subscribe({ next: (_) => {}, error: () => {} });
            }
          },
        );
      },
      error: (_err) => {
        (window as any).HubSpotConversations?.widget.load();
      },
    });
  }

  public initIfNeeded() {
    if (this.hasInitialized) {
      return;
    }

    // if (!this.auth.isAuthenticated() || environment.production !== true) {
    //   return;
    // }

    this.us.me(false).subscribe((me) => {
      this.initHubspot();

      if (this.us.checkUserHasPermission(me, "proctor")) {
        return;
      }

      this.initTracking();

      if (
        !this.us.checkUserHasPermission(me, "moderator") &&
        !this.us.checkUserHasPermission(me, "admin")
      ) {
        // Load Hotjar
        this.hj.init();
      }

      this.hasInitialized = true;
    });
  }
}
